"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMergeViewContainer = SocialMergeViewContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _events = require("../../types/events");
var _view = require("../../types/view");
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _FormFieldHelper = require("../../components/FormFieldHelper");
var _ContentLayout = require("../../components/ContentLayout");
var _PasswordField = require("../../components/PasswordField");
var _Link = require("../../components/Link");
var _tracking = require("../../utils/tracking");
var _keyCodes = require("../../types/keyCodes");
var _FieldGroupLayout = require("../../components/FieldGroupLayout");
var _SubtitleLayout = require("../../components/SubtitleLayout");
var _HelpContainer = require("../HelpContainer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SocialMergeViewContainer(_ref) {
  let {
    hasInitialError,
    isSubmitting,
    email,
    socialLoginId,
    socialType,
    hasMergeError,
    mergeError,
    source,
    changeView,
    emit,
    merge
  } = _ref;
  // FORM

  const [changed, setChanged] = React.useState(hasInitialError);
  const [touched, setTouched] = React.useState(false);
  // PASSWORD
  const [password, setPassword] = React.useState('');
  const [isInvalid, setInvalid] = React.useState(false);
  const [passwordShown, setPasswordShown] = React.useState(false);
  const togglePasswordVisibility = React.useCallback(() => setPasswordShown(!passwordShown), [passwordShown]);
  const handlePasswordChange = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    setPassword(value);
    setChanged(true);
    setInvalid(!value);
  }, []);
  const handleForgotPasswordClick = React.useCallback(event => {
    event.preventDefault();
    (0, _tracking.trackForgotPasswordClickMerge)(source);
    changeView(_view.EActiveView.Restore, {
      email
    });
  }, [changeView, email, source]);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    if (isInvalid) {
      return;
    }
    setChanged(false);
    (0, _tracking.trackSocialMergeMergeClick)(source);
    merge({
      socialType,
      socialLoginId,
      email,
      password,
      source
    });
    emit(_events.EEventType.SocialMergeMergeClick);
  }, [isInvalid, socialType, socialLoginId, email, password, source, merge, emit]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  React.useEffect(() => {
    (0, _tracking.trackSocialAuthenticateEmailTaken)(source);
  }, []);
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackLoginNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, null, "\u0423 \u0432\u0430\u0441 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0441 \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u043E\u0439 ", /*#__PURE__*/React.createElement("strong", null, email), ", \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F."), /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_PasswordField.PasswordField, {
      id: "social_merge-password",
      name: "password",
      placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
      autoFocus: true,
      invalid: touched && (hasMergeError && !changed || isInvalid),
      errorMessage: touched && hasMergeError ? mergeError : undefined,
      value: password,
      onChange: handlePasswordChange,
      onKeyDown: handleSubmitOnEnter,
      disabled: isSubmitting,
      passwordShown: passwordShown,
      toggleVisibility: togglePasswordVisibility
    }), /*#__PURE__*/React.createElement(_FormFieldHelper.FormFieldHelper, {
      alignment: _FormFieldHelper.EAlignment.Right,
      marginBottom: true
    }, /*#__PURE__*/React.createElement(_Link.Link, {
      href: "#",
      onClick: handleForgotPasswordClick
    }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"))),
    buttons: /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "MergeBtn",
      theme: "fill_primary",
      fullWidth: true,
      disabled: isSubmitting,
      loading: isSubmitting,
      onClick: handleSubmit
    }, "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C")
  }))), /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
    onClick: handleHelpClick
  }));
}